<template>
	<div ref="scrollContainer" id="page-panel" >
    <resize-observer @notify="__resizeHanlder" />
		<div class="customer-top-nav no-print">
			<div class="title">
				<span>{{$t('left-menu.sales-orders')}}</span>
			</div>
			<div class="controls">
				<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
					<el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
					<el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
				</el-radio-group>
				 <el-button type="primary" @click="openSODialog" size="small"><i class="mdi mdi-plus-circle"><span style="padding-left:5px;">{{$t('common.New')}}</span></i> </el-button>
				 <el-button size="small" @click="downloadReport('EXCEL')" class="mr-10">
					<i class="mdi mdi-download"></i>
				</el-button>
			</div>
		</div>
    <el-row>
      <el-col :span="leftPanelSpan" >
        <SalesOrdersList @select="selectSO" @new="openSODialog" @invoiceSelectedSalesOrder="createInvoice" @duplicate="handleDuplication"></SalesOrdersList>
			</el-col>
      <el-col :span="rightPanelSpan" v-if="showRightPanel" class="salesOrderDetail">
        <SalesOrdersView @close="closeSelectedSO" @editSalesOrder="openSalesOrderEditor" @duplicate="handleDuplication"></SalesOrdersView>
			</el-col>
    </el-row>
    <CreateSalesOrderDialog :dialogVisible.sync="soDialogVisible" :editSelectedSalesOrder="editSelectedSalesOrder" @close="closeSODialog" ></CreateSalesOrderDialog>
    <InvoiceEditor :visible="invoiceEditorVisible" :editInvoice="invoiceToEdit" @close="closeInvoiceEditor" @created="invoiceCreated"></InvoiceEditor>
	</div>

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import CreateSalesOrderDialog from '@/components/salesOrder/create-sales-order-dialog.vue'
import SalesOrdersList from './components/sales-orders-list'
import SalesOrdersView from './components/sales-order-view'
import InvoiceEditor from '@/components/invoice/invoice-editor'
import InvoiceAPI from '@/services/API/invoice'


export default {
  data() {
    return {
      leftPanelSpan : 24,
      pageWidth : 0,
			pageHeight : 0,
      rightPanelSpan:0,
      showRightPanel:false,
      search : '',
      soDialogVisible : false,
			editSelectedSalesOrder : null,
      invoiceEditorVisible : false,
      invoiceToEdit : null,
	  downloading: false,
    };
  },components: {
    CreateSalesOrderDialog,
		SalesOrdersList,
		SalesOrdersView,
    InvoiceEditor
  },
	methods: {
	downloadReport(format){
      this.downloading=true;

      return this.downloadSalesOrderExcelExport('sales-orders.xlsx')
        .then(()=>{
          this.downloading=false;
        }).catch(err=>{
          console.log(err);
          this.downloading=false;
          this.$message.error("Oops... Une erreur est survenue!");
        })
    },
    handleDownloadCSV(report, type) {
			// return this.getQueryParams()
			// 	.then((params) => {
			// 		return salesOrderA.downloadCustomerExtraction(report, type, params)
			// 	})
		},
    handleDuplication (so) {
      this.duplicate(so);
      this.openSODialog();
    },
    createInvoice(selectedSalesOrder){
      this.setLoadingSalesOrder(true);
      let selectedSalesOrderIds = _.map(selectedSalesOrder, o => o.id)
      InvoiceAPI.convertSalesOrdersToInvoice({ salesOrdersId: selectedSalesOrderIds})
        .then((invoice) => {
          this.invoiceToEdit = invoice;
          this.setLoadingSalesOrder(false);
          this.openInvoiceEditor();
        }).catch((err) => {
          console.log(err);
          this.setLoadingSalesOrder(false);
        })
    },
    invoiceCreated(invoice){
      this.closeInvoiceEditor();
      this.invalidateSalesOrderList();
      this.fetchSalesOrders();
      var index="invoices/"+invoice.id;
      this.$router.push(index);
    },
    openInvoiceEditor(){
      this.invoiceEditorVisible=true;
    },
    closeInvoiceEditor(){
      this.invoiceEditorVisible=false;
      this.invoiceToEdit=null;
    },
		openSalesOrderEditor(){
			this.editSelectedSalesOrder = this.selectedSalesOrder;
			this.openSODialog();
		},
		selectSO(so, index){
			this.selectSalesOrder({salesOrderId : so.id, index:index});
			if(this.pageWidth<1054){
        this.leftPanelSpan=0;
        this.rightPanelSpan = 24;
      }else{
        this.leftPanelSpan=8;
        this.rightPanelSpan=16;
      }
			this.showRightPanel=true;
		},
		closeSelectedSO(){
			this.rightPanelSpan=0;
      this.leftPanelSpan=24;
      this.showRightPanel=false;
		},
    openSODialog(){
      this.soDialogVisible=true;
    },
    closeSODialog(){
      this.soDialogVisible=false;
			this.editSelectedSalesOrder = null;
    },
    close(){
			this.$router.go(-1);
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
			this.setPageWidth();
		}, 700),
		...mapActions('salesOrders', [ 'fetchSalesOrders','selectSalesOrder','initSalesOrders','changeMode','invalidateSalesOrderList','setLoadingSalesOrder', 'downloadSalesOrderExcelExport']),
    ...mapActions('salesOrderEditor', ['duplicate'])
	},
	computed: {
		modeModel : {
			get(){ return this.mode},
			set(mode){this.closeSelectedSO();this.changeMode(mode)}
		},
		...mapState('salesOrders', [ 'salesOrders', 'selectedSalesOrder','mode']),
	},
  mounted(){

    this.setPageWidth()
  },
	created(){
    this.invalidateSalesOrderList();
		this.initSalesOrders();
		this.fetchSalesOrders();

	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}

.salesOrderDetail{
	padding-left:10px;
}

@media (max-width: 1024px) {

	#page-panel{
		padding:0px;
		margin:0px;
	}

	.salesOrderDetail{
		padding-left:0px;
	}

	.customer-top-nav{
		height:60px;
		padding-top:10px;
		padding-left:10px;
		padding-right:10px;
	}

  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
